import { CompletedJobDocumentType } from "@/lib/supabase/supabaseTypes";
import { RecipientTypeEnum } from "./types";

export interface RecipientTableRow {
	tableRowType: 'recipient';
	recipientId: string;
	recipientType: RecipientTypeEnum;
	recipientName: string;
	totalAmount: number;
	jobDocumentCount: number;
	clientId: string;
	subRows: JobDocumentTableRow[];
	// For selection state tracking
	selectedJobDocumentIds: Set<number>;
	allJobDocumentIds: Set<number>;
	// Conflict tracking
	hasMixedVAT: boolean;
	vatRates: Set<number>;
	hasMixedMwstNumber: boolean;
	mwstNumbers: Set<string>;
	hasMixedMwstType: boolean;
	mwstTypes: Set<boolean>;
	hasMixedRounding: boolean;
	roundingModes: Set<number>;
	hasMixedCurrency: boolean;
	currencies: Set<string>;
	// Sorting state
	sortColumn: string | null;
	sortDirection: 'asc' | 'desc';
}

export interface JobDocumentTableRow extends CompletedJobDocumentType {
	tableRowType: 'jobDocument';
	recipientId: string;
	recipientType: RecipientTypeEnum;
	clientId: string;
}

export type SammelrechnungTableRow = RecipientTableRow | JobDocumentTableRow;

export interface SammelrechnungTableActions {
	onOpenPatientDetail: (patientId: string) => void;
	onOpenJobDetail: (jobId: number) => void;
	onSelectJobDocument: (jobDocumentId: number, recipientKey: string) => void;
	onCycleRecipientSelection: (recipientKey: string) => void;
	onCreateInvoice: (recipientKey: string, selectedJobDocIds: number[]) => void;
	onInvoiceDateChange: (recipientKey: string, date: Date) => void;
	getSelectedJobsConflicts?: (recipientKey: string) => string[];
}

export enum CheckboxState {
	EMPTY = 'empty',
	FULL = 'full',
	PARTIAL = 'partial',
	DATE_FILTERED = 'date_filtered'
}